var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"none","width":"24","height":"24","transform":"translate(0 0)","key":0}),React.createElement("path",{"fill":"white","d":"M896.906,633.881,890.82,627.8a9.753,9.753,0,1,0-2.9,2.9l6.086,6.086Zm-14.262-5.726a5.638,5.638,0,1,1,5.638-5.638A5.644,5.644,0,0,1,882.644,628.155Z","transform":"translate(-872.906 -612.779)","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24.001","viewBox":"0 0 24 24.001"};

module.exports = Search;

Search.default = Search;
